import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "rooms-rates-section my-4" };
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_4 = { class: "d-flex gap-2" };
const _hoisted_5 = {
    key: 0,
    class: "rooms-grid"
};
const _hoisted_6 = {
    key: 0,
    class: "room-media"
};
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { class: "room-content" };
const _hoisted_9 = { class: "h6 mb-1" };
const _hoisted_10 = { class: "text-muted mb-2" };
const _hoisted_11 = {
    key: 0,
    class: "amenities list-inline mb-2"
};
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2" };
const _hoisted_13 = { class: "price" };
const _hoisted_14 = { class: "d-flex gap-2" };
const _hoisted_15 = ["href"];
const _hoisted_16 = {
    key: 1,
    class: "text-center mt-3"
};
const _hoisted_17 = {
    key: 2,
    class: "text-muted"
};
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RoomsRatesSection',
    props: {
        rooms: {},
        hotelName: {},
        phoneOrWhatsapp: {},
        pageSize: {}
    },
    setup(__props) {
        const props = __props;
        const checkIn = ref('');
        const checkOut = ref('');
        const pageSize = computed(() => Math.max(1, props.pageSize ?? 6));
        const visibleCount = ref(pageSize.value);
        const visibleRooms = computed(() => (props.rooms || []).slice(0, visibleCount.value));
        const canShowMore = computed(() => (props.rooms?.length || 0) > visibleCount.value);
        const showMore = () => { visibleCount.value = Math.min((props.rooms?.length || 0), visibleCount.value + pageSize.value); };
        const formatPrice = (price) => {
            const n = Math.abs(typeof price === 'string' ? parseFloat(price) : price);
            if (Number.isNaN(n))
                return 'Consultar precio';
            return `$${n.toFixed(0)}/noche`;
        };
        const getRoomImage = (room, roomIndex) => {
            // Array de imágenes de habitaciones de hoteles de internet
            const hotelImages = [
                'https://d1vp8nomjxwyf1.cloudfront.net/wp-content/uploads/sites/51/2016/11/22164807/arrizul_congress_gallery_doble_deluxe_021.jpg',
                'https://sc04.alicdn.com/kf/H2c670b87340242e7ba2126d826dfed98C.jpg',
                'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=400&h=300&fit=crop',
                'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=400&h=300&fit=crop',
                'https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=400&h=300&fit=crop',
                'https://images.unsplash.com/photo-1595576508898-0ad5c879a061?w=400&h=300&fit=crop',
                'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop',
                'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=400&h=300&fit=crop'
            ];
            // Usar el índice de la habitación en el array para garantizar imágenes diferentes
            const imageIndex = roomIndex % hotelImages.length;
            // Debug: mostrar qué imagen se está seleccionando
            console.log(`Room Index: ${roomIndex}, Image Index: ${imageIndex}, Image URL: ${hotelImages[imageIndex]}`);
            return hotelImages[imageIndex];
        };
        const whatsAppUrl = (room) => {
            const phone = (props.phoneOrWhatsapp || '').replace(/[^\d+]/g, '') || '';
            const msg = encodeURIComponent(`Hola, quisiera consultar disponibilidad para la habitación "${room.name}" en ${props.hotelName || 'su hotel'} del ${checkIn.value || 'fecha llegada'} al ${checkOut.value || 'fecha salida'}.`);
            const base = phone ? `https://wa.me/${phone}?text=${msg}` : `https://wa.me/?text=${msg}`;
            return base;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "h5 m-0" }, [
                            _createElementVNode("i", { class: "fas fa-door-open me-2" }),
                            _createTextVNode("Habitaciones y tarifas")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((checkIn).value = $event)),
                                class: "form-control form-control-sm",
                                "aria-label": "Fecha de llegada"
                            }, null, 512), [
                                [_vModelText, checkIn.value]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((checkOut).value = $event)),
                                class: "form-control form-control-sm",
                                "aria-label": "Fecha de salida"
                            }, null, 512), [
                                [_vModelText, checkOut.value]
                            ])
                        ])
                    ]),
                    (_ctx.rooms && _ctx.rooms.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRooms.value, (room, index) => {
                                return (_openBlock(), _createElementBlock("article", {
                                    key: room.id,
                                    class: "room-card"
                                }, [
                                    (room.photos && room.photos.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("img", {
                                                src: getRoomImage(room, index),
                                                alt: room.name
                                            }, null, 8, _hoisted_7)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("h4", _hoisted_9, _toDisplayString(room.name), 1),
                                        _createElementVNode("p", _hoisted_10, "Capacidad: " + _toDisplayString(room.capacity) + " • Camas: " + _toDisplayString(room.beds), 1),
                                        (room.amenities && room.amenities.length)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.amenities, (a, i) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: i,
                                                        class: "list-inline-item badge rounded-pill bg-light text-dark border"
                                                    }, _toDisplayString(a), 1));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("strong", _hoisted_13, _toDisplayString(formatPrice(room.pricePerNight)), 1),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("a", {
                                                    href: whatsAppUrl(room),
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    class: "btn btn-sm btn-outline-success btn-cta"
                                                }, _cache[3] || (_cache[3] = [
                                                    _createElementVNode("i", { class: "fab fa-whatsapp me-1 icon-small" }, null, -1),
                                                    _createTextVNode("Consultar ", -1)
                                                ]), 8, _hoisted_15),
                                                _cache[4] || (_cache[4] = _createElementVNode("button", { class: "btn btn-sm btn-primary btn-cta" }, "Reservar", -1))
                                            ])
                                        ])
                                    ])
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (canShowMore.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                                class: "btn btn-outline-primary btn-sm",
                                onClick: showMore
                            }, "Ver más")
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, "No hay tipos de habitación disponibles."))
                ])
            ]));
        };
    }
});
